import HARDCODE from '../../business-const/HardCode/HardCode'

import {
    COLOR
} from '../../business-const/Color/Color'



const statusAporteList = [
    {
        id: HARDCODE.idStatusAportePendente,
        descricao: 'Pendente',
        ordem: 10,
        corDestaque: COLOR().corDestaquePreto,
    },
    {
        id: HARDCODE.idStatusAporteRealizado,
        descricao: 'Realizado',
        ordem: 20,
        corDestaque: COLOR().corDestaqueVerde,
    },
    {
        id: HARDCODE.idStatusAporteNaoRealizado,
        descricao: 'Não Realizado',
        ordem: 30,
        corDestaque: COLOR().corDestaqueVermelho,
    },
]

export default statusAporteList